import { colors } from "../theme/muiColors";
import { tokenRefs } from "../theme/tokens";

// Colores base
const primaryColor = colors.blue[700];
const primaryText = colors.blue[300];
const secondaryColor = colors.blueGrey[500];
const secondaryText = colors.blueGrey[300];

// Helpers para seleccionar estilos de item seleccionado
const makeSelectedStyle = (color) => ({
  "&.Mui-selected": {
    color,
  },
});

export const styleConfig = {
  sidebar: {
    bg: tokenRefs.surface.sidebar,
    bgSecundary: tokenRefs.surface.sidebarMuted,
    color: tokenRefs.surface.sidebarText,
    hoverBg: tokenRefs.surface.sidebarHover,
    activeBg: tokenRefs.surface.sidebarActive,
  },
  topbar: {
    bg: tokenRefs.surface.base,
    color: tokenRefs.surface.text,
  },
  mainBg: tokenRefs.surface.page,

  tabIndicatorStyles: {
    primary: {
      "& .MuiTabs-indicator": {
        backgroundColor: primaryColor,
      },
    },
    secondary: {
      "& .MuiTabs-indicator": {
        backgroundColor: secondaryColor,
      },
    },
  },

  tabItemSelectedStyles: {
    primary: makeSelectedStyle(primaryColor),
    secondary: makeSelectedStyle(secondaryColor),
  },

  tabItemStyles: {
    primary: {
      textTransform: "capitalize",
      color: primaryText,
      fontSize: "16px",
      ...makeSelectedStyle(primaryColor),
    },
    secondary: {
      textTransform: "capitalize",
      color: secondaryText,
      fontSize: "14px",
      ...makeSelectedStyle(secondaryColor),
    },
  },
};
